// extracted by mini-css-extract-plugin
export default {"card__img":"Card_card__img__-tpem","card__link":"Card_card__link__lC3DT","card__title":"Card_card__title__YY7eh","card__text":"Card_card__text__GqiNT"};